import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  layout: {
    height: '100vh',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  children: {
    position: 'relative',
    // top: theme.palette.custom.headerHeight,
    // left: theme.palette.custom.sidebarWidth,
    // width: `calc(100% - ${theme.palette.custom.sidebarWidth}px)`,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      left: 0,
      right: 0,
      width: '100%',
    },
  },
}))

export default useStyles
